const ALLOWED_PROTOCOLS = ['http:', 'https:'];

// Mirrors backend/utils/safeUrl.js. Applied again at render time because rows
// written before the backend check existed may still hold other schemes.
export function safeUrl(value) {
  if (!value) {
    return '';
  }

  const raw = String(value).trim();
  if (!raw) {
    return '';
  }

  try {
    const parsed = new URL(raw);
    return ALLOWED_PROTOCOLS.includes(parsed.protocol) ? raw : '';
  } catch {
    return '';
  }
}
